import { useAsync } from './useAsync';

export const useGeoLocation = () => {
    const { value: location } = useAsync(async () => {
        const location = await new Promise<GeolocationPosition | null>((resolve) => {
            navigator.geolocation.getCurrentPosition(
                (res) => {
                    resolve(res);
                },
                () => {
                    resolve(null);
                }
            );
        });

        return location?.coords ? location.coords : undefined;
    }, []);

    return location;
};
